var React = require('react');

function Rows12 (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12 3V0H0v3h12Zm0 1.5v3H0v-3h12ZM12 9v3H0V9h12Z","fill":"currentColor"}));
}

Rows12.defaultProps = {"width":"12","height":"12","fill":"none"};

module.exports = Rows12;

Rows12.default = Rows12;
